import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { FiMail, FiLock } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

export default function AdminLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(form.email, form.password); toast.success('Welcome back!'); navigate('/admin'); }
    catch { toast.error('Invalid credentials'); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #060F1E 0%, #0B2545 60%, #13315C 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: 'Outfit, sans-serif', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: -100, right: -100, width: 500, height: 500, borderRadius: '50%', background: 'rgba(201,168,76,0.04)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -80, left: -80, width: 400, height: 400, borderRadius: '50%', background: 'rgba(201,168,76,0.03)', pointerEvents: 'none' }} />
      <motion.div initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} style={{ background: 'white', borderRadius: '24px', padding: '3rem', width: '100%', maxWidth: 440, boxShadow: '0 32px 80px rgba(0,0,0,0.35)', position: 'relative' }}>
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ width: 60, height: 60, background: 'linear-gradient(135deg, #C9A84C, #E8C96A)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.25rem', fontFamily: 'Fraunces, serif', fontWeight: 700, fontSize: '1.5rem', color: '#0B2545' }}>S</div>
          <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.6rem', color: 'var(--navy)', marginBottom: '0.25rem' }}>Admin Portal</h1>
          <p style={{ color: 'var(--gray-400)', fontSize: '0.875rem' }}>Smart Quality Systems</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div style={{ position: 'relative' }}>
              <FiMail style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)', fontSize: '1rem' }} />
              <input className="form-input" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} style={{ paddingLeft: '2.75rem' }} placeholder="admin@smartqualitysystems.com" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <FiLock style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)', fontSize: '1rem' }} />
              <input className="form-input" type="password" required value={form.password} onChange={e => setForm({...form, password: e.target.value})} style={{ paddingLeft: '2.75rem' }} placeholder="••••••••" />
            </div>
          </div>
          <button type="submit" className="btn btn-navy" style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem', padding: '0.875rem', fontSize: '0.95rem', borderRadius: '12px' }} disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
